require('./_set-species')('Array');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/core-js/2.4.0/core-js/modules/es6.array.species.js
 ** module id = 347
 ** module chunks = 0
 **/